module.exports = __webpack_public_path__ + "img/JP.019a6497.png";